import { graphql, useStaticQuery } from 'gatsby';

/**
 * Получаю список категорий
 * @param callback
 * @returns {*}
 */
export default ({ children, options: { id } = {} }) => {
  let data = useStaticQuery(graphql`
    {
      allCategoryJson(sort: { fields: order }, limit: 1000) {
        edges {
          node {
            title
            fields {
              id
              uri
            }
            groups {
              title
              short_title
              id
              description
            }
          }
        }
      }
    }
  `);

  data = data.allCategoryJson.edges.map(({ node }) => ({
    title: node.title,
    id: node.fields.id,
    uri: node.fields.uri,
    groups: node.groups.reduce(
      (list, item) => ({
        ...list,
        [item.id]: {
          title: item.title,
          short_title: item.short_title,
          description: item.description
        }
      }),
      {}
    )
  }));

  if (id) {
    data = data.filter(item => item.id === id);
    if (data.length > 0) {
      data = data[0];
    } else {
      data = null;
    }
  }

  return children(data);
};
